
import { defineComponent } from 'vue';
import AppHeader from '@/components/AppHeader.vue';
import AppFilters from '@/components/AppFilters.vue';
import AppTodoList from '@/components/AppTodoList.vue';
import AppAddTodo from '@/components/AppAddTodo.vue';
import AppFooter from './components/AppFooter.vue';
import { Item } from '@/types/Item';
import { Filter } from '@/types/Filter';
import { Stats } from '@/types/Stats';

interface State {
  items: Item[];
  activeFilter: Filter;
}

export default defineComponent({
  components: {
    AppHeader,
    AppFilters,
    AppTodoList,
    AppAddTodo,
    AppFooter,
  },

  data(): State {
    return {
      items: [
        { id: 1, text: 'Learn the basics of Vue', status: true },
        { id: 2, text: 'Learn the basics of Typescript', status: false },
        { id: 3, text: 'Learn the basics of Nuxt', status: false },
      ],
      activeFilter: 'All',
    };
  },

  computed: {
    filteredItems(): Item[] {
      switch (this.activeFilter) {
        case 'Active':
          return this.activeItems;
        case 'Done':
          return this.doneItems;
        default:
          return this.items;
      }
    },

    stats(): Stats {
      return {
        active: this.activeItems.length,
        done: this.doneItems.length,
      };
    },

    activeItems(): Item[] {
      return this.items.filter((item) => !item.status);
    },

    doneItems(): Item[] {
      return this.items.filter((item) => item.status);
    },
  },

  methods: {
    addItem(item: Item): void {
      this.items.push(item);
    },

    toggleItem(id: number): void {
      const targetItem = this.items.find((item: Item) => item.id === id);

      if (targetItem) {
        targetItem.status = !targetItem.status;
      }
    },

    removeItem(id: number): void {
      this.items = this.items.filter((item: Item) => item.id !== id);
    },

    setFilter(filter: Filter): void {
      this.activeFilter = filter;
    },
  },
});
